import { useAws } from "src/networking/aws";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  PostPolicy,
  PutPolicy,
} from "src/types";

export const usePostPolicy = <
  T extends PostPolicy["request"],
  D extends PostPolicy["response"]
>() => {
  const hook = useAws<T, D>("postPolicy");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "post",
          path: `/polizza/create`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const usePutPolicy = <
  T extends PutPolicy["request"],
  D extends PutPolicy["response"]
>() => {
  const hook = useAws<T, D>("putPolicy");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "put",
          path: `/polizza/${request.uriParams.idPolizza}`,
          ...request,
        },
        callbacks
      );
    },
  };
};
